// extracted by mini-css-extract-plugin
module.exports = {"footer":"Footer_footer__2-UlU","row":"Footer_row__1sMPs","col":"Footer_col__2mQsM","copyRightFooter":"Footer_copyRightFooter__19soJ","dealAndGoLogo":"Footer_dealAndGoLogo__xXoe6"};